import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import Header from "../../header/header";
import NavBar from "../../nav/nav-bar";
import Footer from "../../footer/footer";
import { NotificationContainer } from "react-notifications";
import ReportNav from "../report-nav";
import detail from "../../assets/images/detail.svg";
import page from "../../assets/images/page.svg";
import exportIcon from "../../assets/images/export.svg";
import callReport from "../../assets/images/call-report.svg";
import customer from "../../assets/images/customer.svg";
import process from "../../assets/images/process.svg";
import callClosing from "../../assets/images/call-closing.svg";
import service from "../../assets/images/service.svg";
import documentIcon from "../../assets/images/document.svg";
import call from "../../assets/images/call.svg";
import serviceIcon from "../../assets/images/service.svg";
import score from "../../assets/images/score.svg";
import scoreBlack from "../../assets/images/score2.svg";
import Service from "../../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";

function Editreport() {
  const { id } = useParams();
  const service = new Service();
  const [data, setData] = useState("");
  const [Loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [changedFields, setChangedFields] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const [reportEditSuccess, setReportEditSuccess] = useState(false);
  const [revised, setrevised] = useState("");

  async function RevisedData() {
    if (id) {
      const res = await service
        .get(`api/call_verification/predue_edit/${id}/`)
        .then((res) => {
          setrevised(res);
        });
    }
  }

  useEffect(() => {
    RevisedData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        // first api call to get the revised
        setLoading(true);
        const revisedResponse = await service.get(
          `api/call_verification/predue_edit/${id}/`,
        );
        setrevised(revisedResponse);
        // second api call, after revised is set
        const endpoint =
          Object.keys(revisedResponse).length > 0
            ? `api/call_verification/predue_edit/${id}/`
            : `api/call_verification/predue_dasboard/${id}/`;

        const dataResponse = await service.get(endpoint);
        setData(dataResponse);

        setFormData({
          call_open_timely_manner: dataResponse.call_open_timely_manner
            ? "Yes"
            : "No",
          standard_opening_spiel: dataResponse.standard_opening_spiel
            ? "Yes"
            : "No",
          verification_security: dataResponse.verification_security
            ? "Yes"
            : "No",
          friendly_confident_tone: dataResponse.friendly_confident_tone
            ? "Yes"
            : "No",
          attentive_listening: dataResponse.attentive_listening ? "Yes" : "No",
          call_control_efficiency: dataResponse.call_control_efficiency
            ? "Yes"
            : "No",
          follow_policies_procedure: dataResponse.follow_policies_procedure
            ? "Yes"
            : "No",
          service_reaminder: dataResponse.service_reaminder ? "Yes" : "No",
          customer_alternative_number: dataResponse.customer_alternative_number
            ? "Yes"
            : "No",
          call_record_clause: dataResponse.call_record_clause ? "Yes" : "No",
          call_avoidance: dataResponse.call_avoidance ? "Yes" : "No",
          pid_process: dataResponse.pid_process ? "Yes" : "No",
          misleading_information: dataResponse.misleading_information
            ? "Yes"
            : "No",
          udcp_process: dataResponse.udcp_process ? "Yes" : "No",
          data_manipulation: dataResponse.data_manipulation ? "Yes" : "No",
          call_recap: dataResponse.call_recap ? "Yes" : "No",
          additional_queries: dataResponse.additional_queries ? "Yes" : "No",
          call_closing: dataResponse.call_closing ? "Yes" : "No",
          probing_questions_effectiveness:
            dataResponse.probing_questions_effectiveness ? "Yes" : "No",
          payment_resolution_actions: dataResponse.payment_resolution_actions
            ? "Yes"
            : "No",
          payment_delay_consequences: dataResponse.payment_delay_consequences
            ? "Yes"
            : "No",
          call_document: dataResponse.call_document ? "Yes" : "No",
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }

    fetchData();
  }, [id]);

  const handleDropdownChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
    setChangedFields((prev) => ({
      ...prev,
      [key]: value === "Yes" ? true : false,
    }));
  };

  const handleSubmit = () => {
    setIsModalOpen(true);
  };

  const handleConfirm = () => {
    setReportEditSuccess(true);
    if (Object.keys(changedFields).length > 0) {
      service
        .post(`api/call_verification/predue_edit/${id}/`, changedFields)
        .then((response) => {
          setData((prev) => ({
            ...prev,
            ...changedFields,
          }));

          setChangedFields({});
          setIsModalOpen(false);
          setReportEditSuccess(false);
          history.push(`/report/revised-report/${id}`);
        })
        .catch((error) => {
          console.error("Update failed:", error);
          setIsModalOpen(false);
        });
    } else {
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const DropdownField = ({ label, name, value }) => (
    <div
      className="px-6 py-4 flex items-center rounded-lg no whitespace-nowrap"
      style={{
        border: "1px solid #C2C2C2",
        width: "100%",
        height: "54px",
        background: "white",
        fontSize: "17px",
        color: "#171717",
      }}
    >
      <span className="" style={{ width: "70%" }}>
        {label}
      </span>
      <span
        className=" mx-8 h-10"
        style={{ backgroundColor: "#828282", width: "1px" }}
      ></span>
      <select
        value={value}
        onChange={(e) => handleDropdownChange(name, e.target.value)}
        className={`font-bold bg-white ${
          value === "Yes" ? "text-green-600" : "text-red-600"
        }`}
        style={{ width: "30%" }}
      >
        <option value="Yes" className="text-green-600">
          Yes
        </option>
        <option value="No" className="text-red-600">
          No
        </option>
      </select>
    </div>
  );

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isModalOpen]);

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      {Loading ? (
        <div
          className="flex justify-center items-center"
          style={{ height: "100vh" }}
        >
          {" "}
          <ClipLoader color="#2056FF" size="50px" />
        </div>
      ) : (
        <div>
          <div className="container-fluid">
            <div
              className="my-call flex flex-col gap-4"
              style={{ background: "none" }}
            >
              <div className="flex items-center bg-white p-4 rounded-xl gap-6">
                <img src={detail} alt="detail" />
                <span
                  className="text-[#484848] font-bold"
                  style={{ color: "#484848", fontSize: "18px" }}
                >
                  Detailed Report <br />
                  Customer: ( Ref# :
                  {`${id.slice(0, 8).toString().toUpperCase()}`} )
                </span>
              </div>
              <div className="flex items-center justify-between bg-white px-4 py-4 rounded-xl">
                <span className=" flex gap-4">
                  <img src={page} alt="detail" />
                  <span
                    className="font-bold"
                    style={{ color: "#271078", fontSize: "16px" }}
                  >
                    Details
                  </span>
                </span>
                {/* <button
                  className="p-3  text-black rounded-lg flex items-center gap-4"
                  style={{ border: "1px solid #C3C3C3" }}
                >
                  <img src={exportIcon} alt="export icon" />
                  Export
                </button> */}
              </div>
              <div
                className="h-auto bg-white p-8 rounded-xl flex flex-wrap gap-8"
                style={{
                  background: "#FDFCFF",
                  border: "1px solid #DFDFDF",
                  color: "#171717",
                  fontSize: "16px",
                }}
              >
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2"> Call Date</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold"> {data?.call_date || "-"}</span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Agent</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold">{data?.agent || "-"}</span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Subscriber Name</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold">
                    {data?.customer_name || "-"}
                  </span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Team Lead</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold">{data?.team_lead || "-"}</span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Audit Date</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold">{data?.audit_date || "-"}</span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Language</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>

                  <span className="font-bold">{data?.language || "-"}</span>
                </div>
                <div
                  className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                  style={{
                    border: "1px solid #C2C2C2",
                    width: "398px",
                    height: "54px",
                    background: "white",
                    fontSize: "17px",
                    color: "#171717",
                  }}
                >
                  <span className=" w-1/2">Loan Product</span>
                  <span
                    className=" mx-8 h-10"
                    style={{ backgroundColor: "#828282", width: "1px" }}
                  ></span>
                  <span className="font-bold">{data?.product || "-"}</span>
                </div>
              </div>
              <div
                className="flex items-center justify-between bg-white px-4 py-4 rounded-xl "
                style={{ height: "56px" }}
              >
                <div className="flex justify-between items-center">
                  <span className=" flex gap-4">
                    <img src={callReport} alt="detail" />
                    <span
                      className="font-bold"
                      style={{ color: "#271078", fontSize: "16px" }}
                    >
                      Call Report
                    </span>
                  </span>
                </div>
                <span className=" flex items-center mr-14 gap-2">
                  <img src={score} alt="score" />
                  <span
                    className=" font-bold"
                    style={{ fontSize: "18px", color: "#271078" }}
                  >
                    {" "}
                    Total Score:
                  </span>
                  <span
                    style={{ fontSize: "18px", color: "#271078" }}
                    className=" font-bold"
                  >
                    {data?.total_points}
                  </span>
                </span>
              </div>
              <div className="flex gap-4">
                <div
                  className="w-1/3  rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={call} alt="call-opening" />
                      Call Opening
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.call_opening_points} Points
                      </span>
                    </span>
                  </div>
                  <DropdownField
                    label="Call Open Timely Manner"
                    name="call_open_timely_manner"
                    value={formData.call_open_timely_manner || "No"}
                  />
                  <DropdownField
                    label="Standard Opening Spiel"
                    name="standard_opening_spiel"
                    value={formData.standard_opening_spiel || "No"}
                  />
                  <DropdownField
                    label="Verification for Account Security"
                    name="verification_security"
                    value={formData.verification_security || "No"}
                  />
                </div>
                <div
                  className="w-1/3  rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={customer} alt="call-opening" />
                      Customer Experience
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.customer_experience_points} Points
                      </span>
                    </span>
                  </div>
                  <DropdownField
                    label="Friendly Confident Tone"
                    name="friendly_confident_tone"
                    value={formData.friendly_confident_tone || "No"}
                  />
                  <DropdownField
                    label="Attentive Listening"
                    name="attentive_listening"
                    value={formData.attentive_listening || "No"}
                  />
                  <DropdownField
                    label="Call Control Efficiency"
                    name="call_control_efficiency"
                    value={formData.call_control_efficiency || "No"}
                  />
                </div>
                <div
                  className="w-1/3  rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={process} alt="call-opening" />
                      Process Compliance
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.process_compliance_points} Points
                      </span>
                    </span>
                  </div>
                  <DropdownField
                    label="Follow Policies Procedure"
                    name="follow_policies_procedure"
                    value={formData.follow_policies_procedure || "No"}
                  />
                  <DropdownField
                    label="Service Remainder"
                    name="service_reaminder"
                    value={formData.service_reaminder || "No"}
                  />
                  <DropdownField
                    label="Customer Alternative Number"
                    name="customer_alternative_number"
                    value={formData.customer_alternative_number || "No"}
                  />
                </div>
              </div>
              <div className="flex gap-4">
                <div
                  className="rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                    width: "67.3%",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={serviceIcon} alt="call-opening" />
                      Service and Policy Compliance
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.service_compliance_points} Points
                      </span>
                    </span>
                  </div>
                  <div className=" flex gap-4 flex-wrap">
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "#171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        Call Record Clause
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.call_record_clause || "No"}
                        onChange={(e) =>
                          handleDropdownChange(
                            "call_record_clause",
                            e.target.value,
                          )
                        }
                        className={`font-bold bg-white ${
                          formData.call_record_clause === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        Call Avoidance
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.call_avoidance || "No"}
                        onChange={(e) =>
                          handleDropdownChange("call_avoidance", e.target.value)
                        }
                        className={`font-bold bg-white ${
                          formData.call_avoidance === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "#171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        Pid Process
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.pid_process || "No"}
                        onChange={(e) =>
                          handleDropdownChange("pid_process", e.target.value)
                        }
                        className={`font-bold bg-white ${
                          formData.pid_process === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "#171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        Misleading Information
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.misleading_information || "No"}
                        onChange={(e) =>
                          handleDropdownChange(
                            "misleading_information",
                            e.target.value,
                          )
                        }
                        className={`font-bold bg-white ${
                          formData.misleading_information === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "#171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        UDCP Process
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.udcp_process || "No"}
                        onChange={(e) =>
                          handleDropdownChange("udcp_process", e.target.value)
                        }
                        className={`font-bold bg-white ${
                          formData.udcp_process === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                    <div
                      className="px-6 py-4 flex  items-center  rounded-lg no whitespace-nowrap"
                      style={{
                        border: "1px solid #C2C2C2",
                        width: "49%",
                        height: "54px",
                        background: "white",
                        fontSize: "17px",
                        color: "#171717",
                      }}
                    >
                      <span className="" style={{ width: "70%" }}>
                        {" "}
                        Data Manipulation
                      </span>
                      <span
                        className=" mx-8 h-10"
                        style={{ backgroundColor: "#828282", width: "1px" }}
                      ></span>
                      <select
                        value={formData.data_manipulation || "No"}
                        onChange={(e) =>
                          handleDropdownChange(
                            "data_manipulation",
                            e.target.value,
                          )
                        }
                        className={`font-bold bg-white ${
                          formData.data_manipulation === "Yes"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                        style={{ width: "30%" }}
                      >
                        <option value="Yes" className="text-green-600">
                          Yes
                        </option>
                        <option value="No" className="text-red-600">
                          No
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  className="w-1/3  rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={callClosing} alt="call-opening" />
                      Call Closing
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.call_closing_points} Points
                      </span>
                    </span>
                  </div>
                  <DropdownField
                    label="Call Recap"
                    name="call_recap"
                    value={formData.call_recap || "No"}
                  />
                  <DropdownField
                    label="Ask Additional Queries"
                    name="additional_queries"
                    value={formData.additional_queries || "No"}
                  />
                  <DropdownField
                    label="Call Closed Properly"
                    name="call_closing"
                    value={formData.call_closing || "No"}
                  />
                </div>
              </div>
              <div className="flex gap-4">
                <div
                  className="w-1/3  rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "auto",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={call} alt="call-opening" />
                      Negotiation Strategy
                    </span>
                    <span className="flex gap-2 items-center">
                      <img src={score} />{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#271078",
                        }}
                      >
                        {data?.negotiation_points} Points
                      </span>
                    </span>
                  </div>
                  <DropdownField
                    label="Probing Questions Effectiveness"
                    name="probing_questions_effectiveness"
                    value={formData.probing_questions_effectiveness || "No"}
                  />
                  <DropdownField
                    label="Payment Resolution Actions"
                    name="payment_resolution_actions"
                    value={formData.payment_resolution_actions || "No"}
                  />
                  <DropdownField
                    label="Payment Delay Consequences"
                    name="payment_delay_consequences"
                    value={formData.payment_delay_consequences || "No"}
                  />
                </div>
                <div
                  className="rounded-xl py-8 px-8 flex flex-col gap-4"
                  style={{
                    backgroundColor: "#FCFCFF",
                    border: "1px solid #DFDFDF",
                    height: "fit-content",
                    width: "32.5%",
                  }}
                >
                  <div className="flex justify-between items-center mb-4 ">
                    <span
                      className="flex gap-4 items-center "
                      style={{
                        color: "#484848",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <img src={documentIcon} alt="call-opening" />
                      Document
                    </span>
                  </div>
                  <DropdownField
                    label="Properly Document the Call"
                    name="call_document"
                    value={formData.call_document || "No"}
                  />
                </div>
              </div>
              <div className="flex mt-4 gap-4 pb-4 px-6">
                <button
                  onClick={handleSubmit}
                  className="py-3 px-6  rounded-lg flex items-center gap-4 save cursor-pointer"
                  style={{ border: "1px solid #C3C3C3" }}
                >
                  Save As
                </button>
                <button
                  onClick={() => history.push("/reports/deviance-analysis")}
                  className="p-3 rounded-lg flex items-center gap-4 hover:bg-red-600 bg-white hover:text-white"
                  style={{ border: "1px solid #C3C3C3" }}
                >
                  Cancel
                </button>
              </div>
              {isModalOpen && (
                <div
                  className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
                  style={{ zIndex: 1000 }}
                >
                  <div
                    className="bg-white p-6 rounded-lg shadow-lg flex flex-col relative"
                    style={{ width: "500px", height: "270px" }}
                  >
                    <h2 className="text-3xl font-bold mb-4 text-center">
                      Confirm Changes
                    </h2>
                    <p className="mb-4 text-center text-2xl">
                      Do you want to make the following changes to the report?
                    </p>
                    <div
                      className="overflow-y-auto mb-4"
                      style={{
                        height: "110px",
                        border: "1px solid #C3C3C3",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <ul className="list-disc pl-5">
                        {Object.keys(changedFields).map((field, index) => (
                          <li key={index} className="text-2xl">
                            {field
                              .replace(/_/g, " ")
                              .slice(0, 1)
                              .toUpperCase() +
                              field
                                .replace(/_/g, " ")
                                .slice(1, field.length)}{" "}
                            : {changedFields[field] ? "Yes" : "No"}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="flex justify-end gap-4 absolute bottom-6 right-6">
                      <button
                        onClick={() => handleConfirm()}
                        className="p-3 rounded-lg flex items-center gap-4 save"
                        style={{ border: "1px solid #C3C3C3" }}
                      >
                        Yes Confirm
                      </button>
                      <button
                        onClick={handleCancel}
                        className="p-3 rounded-lg flex items-center gap-4 hover:bg-red-600 bg-white hover:text-white hover:border-0"
                        style={{ border: "1px solid #C3C3C3" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Footer />
      {reportEditSuccess && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-50"></div>
          <ClipLoader size={50} />
        </div>
      )}
    </div>
  );
}

export default Editreport;
